/**
 * Highcharts instance with extended modules: polar, solid-gauge, sankey, treemap.
 *
 * All shift-analysis charts that need non-standard series types import THIS
 * instance instead of plain `highcharts`.
 */
import Highcharts from "highcharts/esm/highcharts.js";
import "highcharts/esm/highcharts-more.js";
import "highcharts/esm/modules/solid-gauge.js";
import "highcharts/esm/modules/sankey.js";
import "highcharts/esm/modules/treemap.js";

try {
  const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  Highcharts.setOptions({ time: { timezone: localTz } });
} catch {
  /* noop */
}

export default Highcharts;
